import React from 'react'
import PageProgress from '@jarvis.oddle/core/components/PageProgress'
import useCustomisation from 'src/hooks/useCustomisation'

const ShopPageProgress = React.memo(() => {
  const { getSectionFromId } = useCustomisation()
  const color = React.useMemo(() => {
    const { settings = {} } = getSectionFromId('header')
    return settings.navigationLinkFontColor
  }, [getSectionFromId])

  return <PageProgress color={color} />
})

export default ShopPageProgress
